import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShBaseGenericReadonlyFieldComponent } from '../../base-generic-readonly-field/base-generic-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-unsupported-readonly-field',
    templateUrl: './unsupported-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShUnsupportedReadonlyFieldComponent extends ShBaseGenericReadonlyFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(searchRoutingService);
    }
}
